// Called by : src/App.vue (router-view)

<template>
  <div id="page_patience">

    <h1 id="page_patience_title" class="page_title mb-4 px-2">
      {{ sTitlePage }}
    </h1>

    <div id="cardcont" class="question card text-center">

      <div id="cardcont_tete" class="card-header h2 text-white txt_ombre_333" style="">
        {{ sTextHeader }}
      </div> <!-- #cardcont_tete -->

      <div id="cardcont_corps" class="card-body">
        <p id="icon_jauge" class="icon_sablier mt-4 d-none" style="">&#9203;</p>
        <p id="picto_jauge" class="picto_sablier mt-4"><img :src="constants.assets.pictoSablier" alt="jauge" @error="onPictoJaugeError(this.id)"></p>
      </div> <!-- #cardcont_corps -->

      <div id="cardcont_pied" class="card-header h2 text-white txt_ombre_333">
        {{ sTextFooter }}
      </div> <!-- #cardcont_pied -->

    </div> <!-- #cardcont -->

  </div> <!-- #page_patience -->
</template>

<script>
// https://www.w3schools.com/charsets/ref_emoji.asp
// https://www.w3schools.com/charsets/tryit.asp?deci=9203
// https://emojipedia.org/hourglass-not-done/
// http://unicode.org/emoji/charts/full-emoji-list.html
// https://www.quackit.com/character_sets/emoji/emoji_v3.0/unicode_emoji_v3.0_characters_all.cfm
// https://apps.timwhitlock.info/emoji/tables/unicode
// https://apps.timwhitlock.info/unicode/inspect/hex/23F3

import { constants } from '@/constants'

export default {
  data() {
    return {
      sTitlePage: this.$t('patience.title'),
      sTextHeader: this.$t('patience.header'),
      sTextFooter: this.$t('patience.footer'),
      nTimeout: 3000,
      sRouteName: 'assignments',
    }
  },
  methods: {
    goBack() {
      // window.history.back();
      // this.$router.go(-1);
      // this.$router.push({ name: 'assignments' });
      // this.$router.push({ name: this.sRouteName });
    },
    onPictoJaugeError(sId) {
      document.getElementById(sId).src = this.constants.assets.pictoSablier;
    },
  },
  computed: {
    constants() {
      return constants
    },  
    params() {
      return this.$store.state.params
    },  
    model() {
      return this.$store.state.model
    },
    user() {
      return this.$store.state.user
    },
  },
  mounted() {
    this.nTimeout = this.params.patienceTime;

    // Récupération des paramètres de la vue qui appelle celle-ci
    if (this.$route.params.sTitlePage) this.sTitlePage = this.$route.params.sTitlePage;
    if (this.$route.params.sTextHeader) this.sTextHeader = this.$route.params.sTextHeader;
    if (this.$route.params.sTextFooter) this.sTextFooter = this.$route.params.sTextFooter;
    if (this.$route.params.nTimeout) this.nTimeout = this.$route.params.nTimeout;
    if (this.$route.params.sRouteName) this.sRouteName = this.$route.params.sRouteName;

    // !!! Fredo 25/11/2023 : on arrête tout ça, trop de soucis avec le séquentiel, on reviens 
    // au fonctionnement initial, la liste des leçons est récupérée dans 'AssignmentsList.vue'
    /*
    if (0) {
      // Lancement de la temporisation de départ
      var nTime = this.nTimeout / 2; // 1000 = 1 sec ; 10000 = 10 sec; 
      setTimeout(function () {
        console.log("nTimeout", nTime);
      }, nTime);
  
      // On récupère la liste des leçons si nécessaire
      if (this.sRouteName === 'assignments') {
        this.model.getAssignments(this.user.zkp)
          .then((lessonSuccess) => {
            this.$store.commit('setAssignments', lessonSuccess.assignments);
          })
          .catch((lessonError) => {
            console.error('lessonError : ', lessonError);
            console.error('errorMessage : ', lessonError.messages[0].message);   
          })
      }
    }
    */

    // Lancement de la temporisation de fin
    var nTime = this.nTimeout; // 1000 = 1 sec ; 10000 = 10 sec; 
    var sRoute = this.sRouteName;
    var oThis = this;
    setTimeout(function () {
      oThis.$router.push({ name: sRoute });
    }, nTime);
  },
}
// created
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/misc/Patience.vue